import React, { useState } from "react";
import SecondaryMenu from "../shared/SecondaryMenu";
import { makeStyles } from "@material-ui/core/styles";
import Grid from "@material-ui/core/Grid";
import IconButton from "@material-ui/core/IconButton";
import Select from "@material-ui/core/Select";
import Button from "@material-ui/core/Button";
import SvgIcon from "@material-ui/core/SvgIcon";
import LinearProgress from "@material-ui/core/LinearProgress";
import Alert from "@material-ui/lab/Alert";
import ReportProblemOutlinedIcon from "@material-ui/icons/ReportProblemOutlined";
import InfoIcon from "@material-ui/icons/Info";
import { TextField, FormHelperText, Checkbox } from "@material-ui/core";
import MenuItem from "@material-ui/core/MenuItem";
import { useHistory } from "react-router-dom";
import { useForm, Controller } from "react-hook-form";
import KeyboardArrowDownIcon from "@material-ui/icons/KeyboardArrowDown";
import GooglePlaceAutoComplete, { PlaceDetails } from "../shared/GooglePlaceAutoComplete";
import { MaterialUiPickersDate } from "@material-ui/pickers/typings/date";
import "../../style/UserStyleSheet.css";
import api from "../../store/api";
import AddEditLocationHoursRow from "./AddEditLocationHoursRow";
import RadioGroup from "@material-ui/core/RadioGroup";
import Radio from "@material-ui/core/Radio";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import InputAdornment from "@material-ui/core/InputAdornment";
import MailOutlineIcon from "@material-ui/icons/MailOutline";
import DeletePopUp from "../shared/DeletePopUp";
import PatientTransportKPI from "./kpi/PatientTransportKPI";
import AgedCareKPI from "./kpi/AgedCareKPI";
import BillingFormType1 from "./billing/BillingFormType1";
import BillingFormType2 from "./billing/BillingFormType2";
import BillingFormType3 from "./billing/BillingFormType3";
import BillingFormType4 from "./billing/BillingFormType4";
import BillingFormType5 from "./billing/BillingFormType5";
import BillingTypeSelect from "./billing/BillingTypeSelect";
import IAuthState from "../../interfaces/IAuthState";
import { SelectItem, IBillingValues, ITripPlannerValues } from "./types/locationTypes";
import { createBillingValuesObj, prepareBillingDataForRequest, prepareBillingDataFromResponse } from "./billing/billingHelpers";
import ListPlanners from "./planner/ListPlanners";
import { prepareTripPlannerForRequest, prepareTripPlannerFromResponse } from "./planner/plannerHelpers";
import { orderBy, values } from "lodash";
import _ from "lodash";
import { plannerSectionDescription } from "./planner/plannerData";
import { parseIntOrNull } from "./hoursofservice/helpers";
import { ItemTypes } from "../../common/dndHelper";
import { consts } from "../../common/consts";
import ErrorMessage from "../shared/messages/ErrorMessage";

interface AddEditIdProp {
    id: string | null;
    authStore: IAuthState;
}

//#region styles
const useStyles = makeStyles((theme) => ({
    grid: {
        flexGrow: 0,
        maxWidth: `100%`,
        flexBasis: `100%`,
        '& .checkbox-sec': {
            float: "right",
            '& .MuiFormControlLabel-label': {
                color: "#353535",
            },
        },
    },
    root: {
        flexGrow: 1,
    },
    paper: {
        padding: theme.spacing(2),
        textAlign: "center",
        color: theme.palette.text.secondary,
    },
    heading: {
        fontSize: 36,
        fontWeight: 900,
        padding: theme.spacing(0, 0, 2, 0),
    },
    margin: {
        margin: theme.spacing(1),
    },
    extendedIcon: {
        fontSize: "small",
        color: theme.palette.primary.light,
    },
    main: {
        //padding: theme.spacing(0, 20, 0, 50)
        //paddingLeft: 40,
    },
    mainGrid: {
        paddingLeft: 40,
        paddingRight: 40,
        paddingTop: 40,
        margin: theme.spacing(0),
        flexGrow: 0,
        maxWidth: `100%`,
        flexBasis: `100%`,
        //padding: theme.spacing(0, 20, 0, 50)
        //paddingLeft: 40,
    },
    mainTop: {
        //padding: theme.spacing(5, 20, 0, 50)
        //paddingLeft: 40,
        //paddingTop: 40,
    },
    textField: {
        backgroundColor: "#ECECEC",
        height: 30,
    },
    textFieldLable: {
        fontSize: 15,
        color: "#949494",
        fontWeight: "bold",
        padding: theme.spacing(0, 0, 1, 0),
    },
    adhocTextFieldLable: {
        fontSize: 20,
        color: "#949494",
        fontWeight: "bold",
        padding: theme.spacing(0, 0, 1, 0),
    },
    textFieldLabel: {
        fontSize: 15,
        color: "#949494",
        fontWeight: "bold",
    },
    selectField: {
        backgroundColor: "#ECECEC",
        height: 40,
        paddingRight: 0,
    },
    formBtn: {
        margin: theme.spacing(0, 1, 0, 1),
        width: "100px",
        height: "40px",
    },
    formLeft: {
        // margin: theme.spacing(0, 0, 0, 50)
        paddingLeft: 40,
        paddingBottom: 40,
        paddingTop: 40,
    },
    loading: {
        width: "100%",
        "& > * + *": {
            marginTop: theme.spacing(2),
        },
    },
    modal: {
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
    },
    paperModal: {
        backgroundColor: theme.palette.background.paper,
        padding: theme.spacing(2, 4, 3),
    },
    alertRoot: {
        marginTop: 24,
    },
    headingAlert: {
        padding: theme.spacing(0, 0, 2, 0),
    },
    textFieldRoot: {
        width: "100%",
    },
    textFieldInput: {
        backgroundColor: "#ECECEC",
        color: "black",
        height: "40px",
    },
    adhocTextFieldInput: {
        backgroundColor: "#ECECEC",
        color: "black",
        height: "40px",
        width: "50%"
    },
    helpText: {
        color: "red",
        padding: theme.spacing(0, 0, 0, 2),
    },
    closeButton: {
        position: "absolute",
        right: theme.spacing(1),
        top: theme.spacing(1),
        color: theme.palette.grey[500],
    },
    removeHover: {
        backgroundColor: "transparent",
        "&:hover": {
            backgroundColor: "transparent",
        },
    },
    deleteBtn: {
        float: "right",
    },
    servicesCheckbox: {
        "& .Mui-disabled": {
            color: "#000",
        },
        "& .MuiSvgIcon-root": {
            color: "#000",
        },
        "& .MuiIconButton-label:after": {
            content: "none !important",
        },
    },
    clusterSelectField: {
        backgroundColor: "#ECECEC",
        height: 40,
        paddingRight: 0,
        width: "calc(100% - 30px)",
        marginLeft: 30,
    },
    adhocSpan: {
        marginBottom: "10px",
        width: "100%"
    }
}));

function AddEditLocationWidget(props: AddEditIdProp): JSX.Element {
    const history = useHistory();
    const classes = useStyles();
    const id = props.id;
    const { handleSubmit, watch, errors, control, formState, setValue, getValues, setError } = useForm();
    const [editItem, setEditItem] = useState(id ? true : false);
    const [editItemId, setEditItemId] = useState(id);
    const [headingText, setHeadingText] = useState("Locations");
    const [mainHeadingText, setMainHeadingText] = useState(id ? "Edit Location" : "New Location");
    const [loading, setLoading] = useState(false);
    const [customerList, setCustomerList] = useState<SelectItem[]>([]);
    const [clusterList, setClusterList] = useState<SelectItem[]>([]);
    const [open, setOpen] = useState(false);
    const [isEnabled, setIsEnabled] = useState(true);
    const [errorMessage, setErrorMessage] = useState("");
    const [statusMessage, setStatusMessage] = useState("");
    const [googlePlaceDetails, setgooglePlaceDetails] = useState<PlaceDetails | null>(null);
    const [confirmationDialog, setConfirmationDialog] = useState(false);
    const [isPatientTransportVisible, setIsPatientTransportVisible] = useState(false);
    const [isAgedCareVisible, setIsAgedCareVisible] = useState(false);

    const [billingTypes, setBillingTypes] = useState<SelectItem[]>([]);
    const [billingType, setBillingType] = useState<string>("0");
    const [billingRetainerIntervals, setBillingRetainerIntervals] = useState<SelectItem[]>([]);
    const [billingCancellationIntervals, setBillingCancellationIntervals] = useState<SelectItem[]>([]);
    const [billingValuesObj, setBillingValuesObj] = useState<IBillingValues>(createBillingValuesObj());

  const [planners, setPlanners] = useState<ITripPlannerValues[]>([]);
  const [locationid, setlocationid] = useState();

  const [code1AcceptableValues, setcode1AcceptableValues] = useState<SelectItem[]>([]);
  const [code2AcceptableValues, setcode2AcceptableValues] = useState<SelectItem[]>([]);
  const [code3AcceptableValues, setcode3AcceptableValues] = useState<SelectItem[]>([]);
  const [code4AcceptableValues, setcode4AcceptableValues] = useState<SelectItem[]>([]);
  const [customerdetails, setcustomerdetails] = useState<any>("");
  const [updatestate, setupdatestate] = useState<boolean>(false);
  const [checkRules, setcheckRules] = React.useState("");
  let code1AcceptableValuesSI:  SelectItem[];
  let code2AcceptableValuesSI:  SelectItem[];
  let code3AcceptableValuesSI:  SelectItem[];
  let code4AcceptableValuesSI:  SelectItem[];
  const [errorMessageBilling, setErrorMessageBilling] = useState("");
  const [valid, setValid] = useState<boolean>(false);
  React.useEffect(() => {
    setLoading(true);
    if (id) getEditItemData();
    else getAddItemData("");
  }, []);

    const setupBillingData = (model: any) => {
        setBillingTypes(model.billingModels);
        setBillingType(model.billingType ? model.billingType.toString() : "0");
        setBillingValuesObj(prepareBillingDataFromResponse(model));
        setBillingRetainerIntervals(model?.retainerIntervals || []);
        setBillingCancellationIntervals(model?.cancellationIntervals || []);
    };

    const setupPlanners = (model: any) => {
        if (model.tripPlanners && model.tripPlanners.length > 0) {
            const tripPlanners = model.tripPlanners.map((item: any) =>
                prepareTripPlannerFromResponse(item)
            );
            setPlanners(orderBy(tripPlanners, ["sequence"], ["asc"]));
        }
    };

    const addOtherValuesToRequest = (req: any) => {

        const tripPlannersForRequest = planners.map((item: any) => prepareTripPlannerForRequest(item));
        for (let item = 0; item < tripPlannersForRequest.length; item++) {
            if (!tripPlannersForRequest[item].servicedBy)
                tripPlannersForRequest[item].servicedBy = "1";
        }
        const newRequest = {
            ...req,
            ...prepareBillingDataForRequest(billingValuesObj, billingType),
            tripPlanners: tripPlannersForRequest,
        };
        return newRequest;
    };

    const validatePlannersShiftHours = (planners: ITripPlannerValues[]): boolean => {
        let isError: any;
        for (let item = 0; item < planners.length; item++) {
            isError = validatePlannerShiftHours(planners[item]);
            if (isError.isError) {
                setErrorMessage(isError.errMessage);
                return false;
            }
        }
        return true;
    }

    const validatePlannerShiftHours = (planner: ITripPlannerValues): { isError: boolean; errMessage?: string } => {
        let isError: any;
        isError = validatePlannerShiftHoursDay(planner.monFrom, planner.monTo, planner.breakDurationMon, planner.breakStartMon, planner.maxBreakDelayMon, planner.monFromString, planner.monToString, planner.breakDurationMonString, planner.breakStartMonString, planner.maxBreakDelayMonString, "monday");
        if (isError.isError)
            return isError;
        isError = validatePlannerShiftHoursDay(planner.tueFrom, planner.tueTo, planner.breakDurationTue, planner.breakStartTue, planner.maxBreakDelayTue, planner.tueFromString, planner.tueToString, planner.breakDurationTueString, planner.breakStartTueString, planner.maxBreakDelayTueString, "tuesday");
        if (isError.isError)
            return isError;
        isError = validatePlannerShiftHoursDay(planner.wedFrom, planner.wedTo, planner.breakDurationWed, planner.breakStartWed, planner.maxBreakDelayWed, planner.wedFromString, planner.wedToString, planner.breakDurationWedString, planner.breakStartWedString, planner.maxBreakDelayWedString, "wednesday");
        if (isError.isError)
            return isError;
        isError = validatePlannerShiftHoursDay(planner.thurFrom, planner.thurTo, planner.breakDurationThu, planner.breakStartThu, planner.maxBreakDelayThu, planner.thurFromString, planner.thurToString, planner.breakDurationThuString, planner.breakStartThuString, planner.maxBreakDelayThuString, "thursday");
        if (isError.isError)
            return isError;
        isError = validatePlannerShiftHoursDay(planner.friFrom, planner.friTo, planner.breakDurationFri, planner.breakStartFri, planner.maxBreakDelayFri, planner.friFromString, planner.friToString, planner.breakDurationFriString, planner.breakStartFriString, planner.maxBreakDelayFriString, "friday");
        if (isError.isError)
            return isError;
        isError = validatePlannerShiftHoursDay(planner.satFrom, planner.satTo, planner.breakDurationSat, planner.breakStartSat, planner.maxBreakDelaySat, planner.satFromString, planner.satToString, planner.breakDurationSatString, planner.breakStartSatString, planner.maxBreakDelaySatString, "saturday");
        if (isError.isError)
            return isError;
        isError = validatePlannerShiftHoursDay(planner.sunFrom, planner.sunTo, planner.breakDurationSun, planner.breakStartSun, planner.maxBreakDelaySun, planner.sunFromString, planner.sunToString, planner.breakDurationSunString, planner.breakStartSunString, planner.maxBreakDelaySunString, "sunday");
        if (isError.isError)
            return isError;
        return {
            isError: false,
            errMessage: "",
        };
    }

    const checkTimeIsValid = (time: string): boolean => {
        if (time == "")
            return true;
        if (time.split(":").length != 2)
            return false;
        else if (isNaN(time.split(":")[0] as any))
            return false;
        else if (isNaN(time.split(":")[1] as any))
            return false;
        else if (parseInt(time.split(":")[0]) > 23 || parseInt(time.split(":")[0]) < 0)
            return false;
        else if (parseInt(time.split(":")[1]) > 59 || parseInt(time.split(":")[1]) < 0)
            return false;
        return true;
    }

  const validatePlannerShiftHoursDay = (from:number|null,to:number|null,breakDuration:number|null,breakStart:number|null,maxDelay:number|null,fromString:string|null,toString:string|null,breakDurationString:number|null,breakStartString:string|null,maxDelayString:number|null,day:string) : {isError: boolean; errMessage?: string} => {
    if(fromString!=null && !checkTimeIsValid(fromString))
      return {
        isError: true,
        errMessage: "Shift start time on "+day+" is not valid",
      };
    if(toString!=null && !checkTimeIsValid(toString))
      return {
        isError: true,
        errMessage: "Shift end time on "+day+" is not valid",
      };
    if(breakStartString!=null && !checkTimeIsValid(breakStartString))
      return {
        isError: true,
        errMessage: "Break start time on "+day+" is not valid",
      };
    if(from!=null && to!=null && to<=from)
      return {
        isError: true,
        errMessage: "Shift end time should not be lesser than or same as shift start time on "+day+"",
      };
    if(from!=null && to==null)
      return {
        isError: true,
        errMessage: "Shift end time cannot be empty when shift start time is given on "+day+"",
      };
    if(from==null && to!=null)
      return {
        isError: true,
        errMessage: "Shift start time cannot be empty when shift end time is given on "+day+"",
      };
    if((breakDuration==null || breakDuration==0) && breakStart!=null)
      return {
        isError: true,
        errMessage: "Break start time cannot have values when break duration is not given on "+day+"",
      };
    if((breakDuration==null || breakDuration==0) && !(maxDelay==null || maxDelay==0))
      return {
        isError: true,
        errMessage: "Max break delay cannot have values when break duration is not given on "+day+"",
      };
    if(!(breakDuration==null || breakDuration==0) && breakStart==null)
      return {
        isError: true,
        errMessage: "Break start time is not given on "+day+"",
      };
    if(!(breakDuration==null || breakDuration==0) && maxDelay==null)
      return {
        isError: true,
        errMessage: "Max break delay is not given on "+day+"",
      };
    if(!(breakDuration==null || breakDuration==0)  && maxDelay!=null&& (maxDelay>24||maxDelay<0))
      return {
        isError: true,
        errMessage: "Max break delay is not valid on "+day+"",
      };
    if(breakStart!=null && maxDelay!=null && to!=null && breakStart+(maxDelay*60)>to)
      return {
        isError: true,
        errMessage: "Break start time + Max break delay cannot be later than shift end time on "+day+"",
      };
    if(breakDuration!=null && maxDelay!=null && breakDuration>(maxDelay*60))
      return {
        isError: true,
        errMessage: "Break duration cannot be larger than max break delay on "+day+"",
      };
    if((from==null || to==null) && (breakDuration!=null ||breakStart!=null ||maxDelay!=null))
      return {
        isError: true,
        errMessage: "Break details cannot be provided without shift details on "+day+"",
      };
    else
      return {
        isError: false,
        errMessage: "",
      };
  }
  function isDateValid(dateString: string): boolean {
    const date = new Date(dateString);
    // Check if the date is a valid date and not equal to 'Invalid Date'
    return !isNaN(date.getTime());
  }
  
  const validateOpenhours =(): {isError: boolean; errMessage?: any}=>{
    let values = getValues();
    var monFrom = values["openOnMon"] ? ( (values["monFrom"])) :null;
    if(monFrom!=null && !isDateValid(monFrom))
    return {
      isError: true,
      errMessage: "From time of Monday's hours of service is invalid",
    };
    var monTo= values["openOnMon"] ? (values["monTo"]) :null;
    if(monTo!=null &&  !isDateValid(monTo))
    return {
      isError: true,
      errMessage: "To time of Monday's hours of service is invalid",
    };
    var tueFrom= values["openOnTue"] ? (values["tueFrom"]) :null;
    if(tueFrom!=null &&  !isDateValid(tueFrom))
    return {
      isError: true,
      errMessage: "From time of Tuesday's hours of service is invalid",
    };
    var tueTo= values["openOnTue"] ? (values["tueTo"]) : null;
    if(tueTo!=null &&  !isDateValid(tueTo))
    return {
      isError: true,
      errMessage: "To time of Tuesday's hours of service is invalid",
    };
    var wedFrom= values["openOnWed"] ? (values["wedFrom"]) :null;
    if(wedFrom!=null &&  !isDateValid(wedFrom))
    return {
      isError: true,
      errMessage: "From time of Wednesday's hours of service is invalid",
    };
    var wedTo= values["openOnWed"] ? (values["wedTo"]) :null;
    if(wedTo!=null && !isDateValid(wedTo))
    return {
      isError: true,
      errMessage: "To time of Wednesday's hours of service is invalid",
    };
    var  thurFrom= values["openOnThur"] ? (values["thurFrom"]) : null;
    if(thurFrom!=null &&  !isDateValid(thurFrom))
    return {
      isError: true,
      errMessage: "From time of Thursday's hours of service is invalid",
    };
    var thurTo= values["openOnThur"] ? (values["thurTo"]) :null;
    if(thurFrom!=null &&  !isDateValid(thurTo))
    return {
      isError: true,
      errMessage: "To time of Thursday's hours of service is invalid",
    };
    var friFrom= values["openOnFri"] ? (values["friFrom"]) :null;
    if(friFrom!=null &&  !isDateValid(friFrom))
    return {
      isError: true,
      errMessage: "From time of Friday's hours of service is invalid",
    };
    var friTo= values["openOnFri"] ? (values["friTo"]) : null;
    if(friTo!=null &&  !isDateValid(friTo))
    return {
      isError: true,
      errMessage: "To time of Friday's hours of service is invalid",
    };
    var satFrom= values["openOnSat"] ? (values["satFrom"]) : null;
    if(satFrom!=null &&  !isDateValid(satFrom))
    return {
      isError: true,
      errMessage: "From time of Saturday's hours of service is invalid",
    };
    var satTo= values["openOnSat"] ? (values["satTo"]) : null;
    if(satTo!=null &&  !isDateValid(satTo))
    return {
      isError: true,
      errMessage: "To time of Saturday's hours of service is invalid",
    };
    var sunFrom= values["openOnSun"] ? (values["sunFrom"]) : null;
    if(sunFrom!=null && !isDateValid(sunFrom))
    return {
      isError: true,
      errMessage: "From time of Sunday's hours of service is invalid",
    };
    var sunTo= values["openOnSun"] ? (values["sunTo"]) : null;
    if(sunTo!=null && !isDateValid(sunTo))
    return {
      isError: true,
      errMessage: "To time of Sunday's hours of service is invalid",
    };
    else
    return {
      isError: false,
      errMessage: "",
    };

  }

  const checkBillingValues = (): { isError: boolean; errMessage?: string } => {
    if (billingValuesObj.billingRuleVersion != null && billingValuesObj.billingRuleVersion != ""){
      if (!/^\d+$/.test(billingValuesObj.billingRuleVersion)) {
        return {
          isError: true,
          errMessage: "Version is not a valid number",
        };
      }
    }
    if (billingValuesObj.applyCancellationFees === true && _.isEmpty(billingValuesObj.cancellationPeriod)) {
      return {
        isError: true,
        errMessage: "Cancellation fee period cannot be empty",
      };
    }
    if (billingValuesObj.hasRetainer === true && (!billingValuesObj.retainerInterval || !billingValuesObj.retainerTransfersNum)) {
      return {
        isError: true,
        errMessage: "Retainer interval and/or transfers included cannot be empty",
      };
    }
    if (billingValuesObj.transferFeesDoubled === true && !billingValuesObj.maxDistancePerTransfer && !billingValuesObj.timeLimitPerTransfer) {
      return {
        isError: true,
        errMessage: "Distance/duration over value cannot be empty",
      };
    }
    if (billingValuesObj.addWaitTimeFees === true && (!billingValuesObj.waitTimeGracePeriod || !billingValuesObj.waitTimeRatePerHour)) {
      return {
        isError: true,
        errMessage: "Grace period value and/or rate per hour cannot be empty",
      };
    }
    if ((billingValuesObj.commencementDate == null) && (billingValuesObj?.billingRuleFrequency !=null && billingValuesObj.billingRuleFrequency != 0) &&(billingType === "5")) {
      return {
        isError: true,
        errMessage: "Commencement Date cannot be empty",
      };
    }
    
    if (((billingValuesObj.contractedEntity == null || billingValuesObj.contractedEntity ==0)) && (billingValuesObj.billingRuleID!=null && billingValuesObj.billingRuleID !="") &&(billingType === "5")) {
      return {
        isError: true,
        errMessage: "Contracted Entity cannot be empty",
      };
    }
    return {
      isError: false,
    };  
  };

  const IsNullOrEmpty = (Value: any) => {
    if (Value != null && Value != '' && Value != undefined && Value.length > 0)
      return false;
    else
      return true;
  }

  const convertArrayToSelectItem = (value: any) => {
    const Array = value!= null && value.length>0 && value[0] != '' ? value : [];
    let selectItems: SelectItem[];
      selectItems = Array?.length > 0 ? Array.map((item: any, index: any) => ({
        text: item,
        value: item,
        selected: false, // You can set the initial selected state as needed
        disabled: false, // Set the disabled state as needed
      })) : [];
      return selectItems;
  }

  const splitByCommaToArray = (value: any) => {
    if(!IsNullOrEmpty(value)){
      const initialString = value;
      const initialArray = initialString?.split(',');
      const cleanedArray = initialArray?.map((val: any) => val.replace(/"/g, ''));
      return cleanedArray;
    }
    else{
      return null;
    }
  }

  const setLocationcode = (customer: any) => {
    var code1AcceptableValueArray = !IsNullOrEmpty(customer.code1Label) ? splitByCommaToArray(customer.code1AcceptableValues) : null;
    code1AcceptableValuesSI = convertArrayToSelectItem(code1AcceptableValueArray);
    setcode1AcceptableValues(code1AcceptableValuesSI);
     var code2Acceptablevaluearry = !IsNullOrEmpty(customer.code2Label) ? splitByCommaToArray(customer.code2AcceptableValues) : null;
     code2AcceptableValuesSI = convertArrayToSelectItem(code2Acceptablevaluearry);
    setcode2AcceptableValues(code2AcceptableValuesSI);
     var code3Acceptablevaluearry = !IsNullOrEmpty(customer.code3Label) ? splitByCommaToArray(customer.code3AcceptableValues) : null;
     code3AcceptableValuesSI = convertArrayToSelectItem(code3Acceptablevaluearry);
    setcode3AcceptableValues(code3AcceptableValuesSI);
     var code4Acceptablevaluearry = !IsNullOrEmpty(customer.code4Label) ? splitByCommaToArray(customer.code4AcceptableValues) : null;
     code4AcceptableValuesSI = convertArrayToSelectItem(code4Acceptablevaluearry);
    setcode4AcceptableValues(code4AcceptableValuesSI);
  }

  React.useEffect(() => {
    if(customerdetails != "")
        setLocationcode(customerdetails);
  }, [customerdetails]); 

  const getAddItemData = async (customerId: string): Promise<void> => {
    setErrorMessage("");
    setStatusMessage("");
    try {
      const _res = await api.getAddEditLocationLoadData("customerId=" + customerId);
      if (_res !== null && _res.data != null && _res.data.model !== null) {

        if (IsNullOrEmpty(customerId)) {
          setCustomerList(_res.data.model.customers);
          setClusterList(_res.data.model.clusters);
          setupBillingData(_res.data.model);
        }
        else {
          setcustomerdetails(_res.data.model.customer);
          
        }
        setLoading(false);
        resetMessages();
      }
    } catch (error) {
      setErrorMessage("Error happened while adding location");
      setLoading(false);
    }
  };

    const updateDependentComponentState = (fieldName: string, filedValue: any) => {
        switch (fieldName) {
            case "isPatientTransport":
                setIsPatientTransportVisible(filedValue === true);
                break;
            case "isAgedCare":
                setIsAgedCareVisible(filedValue === true);
                break;
            default:
                break;
        }
    };

    const getEditItemData = async (): Promise<void> => {
        try {
            const _res = await api.getEditLocationLoadData("locationId=" + editItemId);

      if (_res !== null && _res.data !== null && _res.data.model !== null) {
        setCustomerList(_res.data.model.customers);
        setClusterList(_res.data.model.clusters);
        setHeadingText(_res.data.model.name);
        setValue("googlePlaceId", _res.data.model.googlePlaceId);
        setcheckRules("null");
        setupBillingData(_res.data.model);
        setupPlanners(_res.data.model);
        setIsEnabled(_res.data.model["isEnabled"]);
        setcustomerdetails(_res.data.model.customer);
        let fields = [
          "name",
          "shortName",
          "customerId",
          "pickupLeadTime",
          "dropoffLeadTime",
          "adhocReminder",
          "monFrom",
          "monTo",
          "tueFrom",
          "tueTo",
          "wedFrom",
          "wedTo",
          "thurFrom",
          "thurTo",
          "friFrom",
          "friTo",
          "satFrom",
          "satTo",
          "sunFrom",
          "sunTo",
          "openOnMon",
          "openOnTue",
          "openOnWed",
          "openOnThur",
          "openOnFri",
          "openOnSat",
          "openOnSun",
          "transfersPerDayYellowAlert",
          "transfersPerDayRedAlert",
          "percentMultiloadYellowAlert",
          "percentMultiloadRedAlert",
          "transfersPerHourYellowAlert",
          "transfersPerHourRedAlert",
          "kmPerTransferYellowAlert",
          "kmPerTransferRedAlert",
          "bookingConfirmation",
          "isAgedCare",
          "isEventMedical",
          "isSMABase",
          "isPatientTransport",
          "clusterId",
          "timeToAcknowledgeYellowAlert",
          "timeToAcknowledgeRedAlert",
          "timeToAttendYellowAlert",
          "timeToAttendRedAlert",
          "calloutsNPSSurveyYellowAlert",
          "calloutsNPSSurveyRedAlert",
          "calloutsPerDayYellowAlert",
          "calloutsPerDayRedAlert",
          "isPublicHoliday",
          "code1AcceptableValue",
          "code2AcceptableValue",
          "code3AcceptableValue",
          "code4AcceptableValue",
        ];
        for (var field in fields) {
          const fieldName = fields[field];
          const filedValue = _res.data.model[fieldName];
          if (fieldName.endsWith("From") || fieldName.endsWith("To") || fieldName.startsWith("breakStart")) {
            if (filedValue) {
              setValue(fieldName, removeUTCOffset(parseTime(filedValue), true));
            }
          } else setValue(fieldName, filedValue ?? "");

                    updateDependentComponentState(fieldName, filedValue);
                }
                setLoading(false);
                resetMessages();
            }
        } catch (error) {
            setErrorMessage("Error happened while editing location");
            setLoading(false);
        }
    };
    const getEditItemDatapopup = async (): Promise<void> => {
        try {
            const _res = await api.getEditLocationLoadDatapopup("locationId=" + editItemId);

            if (_res !== null && _res.data !== null && _res.data.model !== null) {
                setCustomerList(_res.data.model.customers);
                setClusterList(_res.data.model.clusters);
                setHeadingText(_res.data.model.name);
                setValue("googlePlaceId", _res.data.model.googlePlaceId);
                setupBillingData(_res.data.model);
                setupPlanners(_res.data.model);
                let fields = [
                    "name",
                    "shortName",
                    "customerId",
                    "pickupLeadTime",
                    "dropoffLeadTime",
                    "adhocReminder",
                    "monFrom",
                    "monTo",
                    "tueFrom",
                    "tueTo",
                    "wedFrom",
                    "wedTo",
                    "thurFrom",
                    "thurTo",
                    "friFrom",
                    "friTo",
                    "satFrom",
                    "satTo",
                    "sunFrom",
                    "sunTo",
                    "openOnMon",
                    "openOnTue",
                    "openOnWed",
                    "openOnThur",
                    "openOnFri",
                    "openOnSat",
                    "openOnSun",
                    "breakStartMon",
                    "breakStartTue",
                    "breakStartWed",
                    "breakStartThu",
                    "breakStartFri",
                    "breakStartSat",
                    "breakStartSun",
                    "breakDurationMon",
                    "breakDurationTue",
                    "breakDurationWed",
                    "breakDurationThu",
                    "breakDurationFri",
                    "breakDurationSat",
                    "breakDurationSun",
                    "maxBreakDelayMon",
                    "maxBreakDelayTue",
                    "maxBreakDelayWed",
                    "maxBreakDelayThu",
                    "maxBreakDelayFri",
                    "maxBreakDelaySat",
                    "maxBreakDelaySun",
                    "transfersPerDayYellowAlert",
                    "transfersPerDayRedAlert",
                    "percentMultiloadYellowAlert",
                    "percentMultiloadRedAlert",
                    "transfersPerHourYellowAlert",
                    "transfersPerHourRedAlert",
                    "kmPerTransferYellowAlert",
                    "kmPerTransferRedAlert",
                    "bookingConfirmation",
                    "isAgedCare",
                    "isEventMedical",
                    "isSMABase",
                    "isPatientTransport",
                    "clusterId",
                    "timeToAcknowledgeYellowAlert",
                    "timeToAcknowledgeRedAlert",
                    "timeToAttendYellowAlert",
                    "timeToAttendRedAlert",
                    "calloutsNPSSurveyYellowAlert",
                    "calloutsNPSSurveyRedAlert",
                    "calloutsPerDayYellowAlert",
                    "calloutsPerDayRedAlert",
                    "isPublicHoliday",
                ];
                for (var field in fields) {
                    const fieldName = fields[field];
                    const filedValue = _res.data.model[fieldName];
                    if (fieldName.endsWith("From") || fieldName.endsWith("To") || fieldName.startsWith("breakStart")) {
                        if (filedValue) {
                            setValue(fieldName, removeUTCOffset(parseTime(filedValue), true));
                        }
                    } else setValue(fieldName, filedValue ?? "");

                    updateDependentComponentState(fieldName, filedValue);
                }
                setLoading(false);
                resetMessages();
            }
        } catch (error) {
            setErrorMessage("Error happened while editing location");
            setLoading(false);
        }
    };

    const parseTime = (time: any): any | null => {
        if (time?.toString().includes("T")) return time;
        let d = new Date();
        d.setHours(0, 0, 0);
        if (time) {
            d.setHours(time?.toString().split(":")[0]);
            d.setMinutes(time?.toString().split(":")[1]);
        } else return null;
        let tzOffset = d.getTimezoneOffset() * 60000;
        let newDate = new Date(d.getTime() - tzOffset);
        return newDate.toISOString();
    };

  const removeUTCOffset = (dateString: string, offsetBack?: boolean) => {
    const utcDate = new Date(dateString);
    const tzOffSet = utcDate.getTimezoneOffset() * 60000 * (offsetBack ? -1 : 1);
    const offsetTimeString = new Date(utcDate.getTime() - tzOffSet).toISOString();
    return offsetBack ? offsetTimeString : offsetTimeString.substr(11, 5);
  };

  const addNewItem = async (): Promise<void> => {
    setLoading(true);
    setErrorMessage("");
    setStatusMessage("");
    let values = getValues();
    const validateval = validateOpenhours();
    if(validateval.isError)
    {
      setErrorMessage(validateval.errMessage);
      setLoading(false);
      return;
    }
    let _req: { [index: string]: any } = {
      name: values["name"],
      shortName: values["shortName"],
      customerId: values["customerId"] == "" ? null : values["customerId"],
      geoName: googlePlaceDetails?.name,
      streetAddress: googlePlaceDetails?.address_details?.home,
      suburb: googlePlaceDetails?.address_details?.city,
      state: googlePlaceDetails?.address_details?.region,
      postcode: googlePlaceDetails?.address_details?.postal_code,
      longitude: googlePlaceDetails?.lng,
      latitude: googlePlaceDetails?.lat,
      googlePlaceId: values["googlePlaceId"],
      monFrom: removeUTCOffset(values["monFrom"]),
      monTo: removeUTCOffset(values["monTo"]),
      tueFrom: removeUTCOffset(values["tueFrom"]),
      tueTo: removeUTCOffset(values["tueTo"]),
      wedFrom: removeUTCOffset(values["wedFrom"]),
      wedTo: removeUTCOffset(values["wedTo"]),
      thurFrom: removeUTCOffset(values["thurFrom"]),
      thurTo: removeUTCOffset(values["thurTo"]),
      friFrom: removeUTCOffset(values["friFrom"]),
      friTo: removeUTCOffset(values["friTo"]),
      satFrom: removeUTCOffset(values["satFrom"]),
      satTo: removeUTCOffset(values["satTo"]),
      sunFrom: removeUTCOffset(values["sunFrom"]),
      sunTo: removeUTCOffset(values["sunTo"]),
      openOnMon: values["openOnMon"],
      openOnTue: values["openOnTue"],
      openOnWed: values["openOnWed"],
      openOnThur: values["openOnThur"],
      openOnFri: values["openOnFri"],
      openOnSat: values["openOnSat"],
      openOnSun: values["openOnSun"],
      breakStartMon: values["openOnMon"] && values["breakStartMon"] ? removeUTCOffset(values["breakStartMon"]) : "",
      breakStartTue: values["openOnTue"] && values["breakStartTue"] ? removeUTCOffset(values["breakStartTue"]) : "",
      breakStartWed: values["openOnWed"] && values["breakStartWed"] ? removeUTCOffset(values["breakStartWed"]) : "",
      breakStartThu: values["openOnThur"] && values["breakStartThu"] ? removeUTCOffset(values["breakStartThu"]) : "",
      breakStartFri: values["openOnFri"] && values["breakStartFri"] ? removeUTCOffset(values["breakStartFri"]) : "",
      breakStartSat: values["openOnSat"] && values["breakStartSat"] ? removeUTCOffset(values["breakStartSat"]) : "",
      breakStartSun: values["openOnSun"] && values["breakStartSun"] ? removeUTCOffset(values["breakStartSun"]) : "",
      breakDurationMon: parseIntOrNull(values["breakDurationMon"]),
      breakDurationTue: parseIntOrNull(values["breakDurationTue"]),
      breakDurationWed: parseIntOrNull(values["breakDurationWed"]),
      breakDurationThu: parseIntOrNull(values["breakDurationThu"]),
      breakDurationFri: parseIntOrNull(values["breakDurationFri"]),
      breakDurationSat: parseIntOrNull(values["breakDurationSat"]),
      breakDurationSun: parseIntOrNull(values["breakDurationSun"]),
      maxBreakDelayMon: parseIntOrNull(values["maxBreakDelayMon"]),
      maxBreakDelayTue: parseIntOrNull(values["maxBreakDelayTue"]),
      maxBreakDelayWed: parseIntOrNull(values["maxBreakDelayWed"]),
      maxBreakDelayThu: parseIntOrNull(values["maxBreakDelayThu"]),
      maxBreakDelayFri: parseIntOrNull(values["maxBreakDelayFri"]),
      maxBreakDelaySat: parseIntOrNull(values["maxBreakDelaySat"]),
      maxBreakDelaySun: parseIntOrNull(values["maxBreakDelaySun"]),
      pickupLeadTime: parseInt(values["pickupLeadTime"]),
      dropoffLeadTime: parseInt(values["dropoffLeadTime"]),
      adhocReminder: parseInt(values["adhocReminder"]),
      transfersPerDayYellowAlert: Number(values["transfersPerDayYellowAlert"]),
      transfersPerDayRedAlert: Number(values["transfersPerDayRedAlert"]),
      percentMultiloadYellowAlert: Number(values["percentMultiloadYellowAlert"]),
      percentMultiloadRedAlert: Number(values["percentMultiloadRedAlert"]),
      transfersPerHourYellowAlert: Number(values["transfersPerHourYellowAlert"]),
      transfersPerHourRedAlert: Number(values["transfersPerHourRedAlert"]),
      kmPerTransferYellowAlert: Number(values["kmPerTransferYellowAlert"]),
      kmPerTransferRedAlert: Number(values["kmPerTransferRedAlert"]),
      isEnabled: isEnabled,
      bookingConfirmation: Boolean(values["bookingConfirmation"]),
      isAgedCare: Boolean(values["isAgedCare"]),
      isEventMedical: Boolean(values["isEventMedical"]),
      isSMABase: Boolean(values["isSMABase"]),
      isPatientTransport: Boolean(values["isPatientTransport"]),
      clusterId: values["clusterId"] == "" ? null : values["clusterId"],
      timeToAcknowledgeYellowAlert: Number(values["timeToAcknowledgeYellowAlert"]),
      timeToAcknowledgeRedAlert: Number(values["timeToAcknowledgeRedAlert"]),
      timeToAttendYellowAlert: Number(values["timeToAttendYellowAlert"]),
      timeToAttendRedAlert: Number(values["timeToAttendRedAlert"]),
      calloutsNPSSurveyYellowAlert: Number(values["calloutsNPSSurveyYellowAlert"]),
      calloutsNPSSurveyRedAlert: Number(values["calloutsNPSSurveyRedAlert"]),
      calloutsPerDayYellowAlert: Number(values["calloutsPerDayYellowAlert"]),
      calloutsPerDayRedAlert: Number(values["calloutsPerDayRedAlert"]),
      isPublicHoliday: Boolean(values["isPublicHoliday"]),
      code1AcceptableValue :values["code1AcceptableValue"],
      code2AcceptableValue :values["code2AcceptableValue"],
      code3AcceptableValue :values["code3AcceptableValue"],
      code4AcceptableValue :values["code4AcceptableValue"],
    };
    try {
      const billingValidation = checkBillingValues();
      if (billingValidation.isError) {
        setErrorMessage(billingValidation.errMessage ?? "");
        setLoading(false);
        return;
      }
      const requestResponse = await api.addNewLocation("", addOtherValuesToRequest(_req));
      if (!requestResponse.hasError && requestResponse.message !== null) {
        setStatusMessage(requestResponse.message);
        backToList();
      } else {
        setErrorMessage(requestResponse.message ?? "");
      }
      setLoading(false);
    } catch (error) {
     // setErrorMessage(error);
      setLoading(false);
    }
  };

  const updateItem = async (): Promise<void> => {
    setLoading(true);
    setErrorMessage("");
    setStatusMessage("");
    let values = getValues();
    console.log(values);
    const validateval = validateOpenhours();
    if(validateval.isError)
    {
      setErrorMessage(validateval.errMessage);
      setLoading(false);
      return;
    }
    let _req: { [index: string]: any } = {
      locationId: editItemId,
      name: values["name"],
      shortName: values["shortName"],
      customerId: values["customerId"] == "" ? null : values["customerId"],
      geoName: googlePlaceDetails?.name,
      streetAddress: googlePlaceDetails?.address_details?.home,
      suburb: googlePlaceDetails?.address_details?.city,
      state: googlePlaceDetails?.address_details?.region,
      postcode: googlePlaceDetails?.address_details?.postal_code,
      longitude: googlePlaceDetails?.lng,
      latitude: googlePlaceDetails?.lat,
      googlePlaceId: values["googlePlaceId"],
      monFrom: values["openOnMon"] ? removeUTCOffset(values["monFrom"]) : "",
      monTo: values["openOnMon"] ? removeUTCOffset(values["monTo"]) : "",
      tueFrom: values["openOnTue"] ? removeUTCOffset(values["tueFrom"]) : "",
      tueTo: values["openOnTue"] ? removeUTCOffset(values["tueTo"]) : "",
      wedFrom: values["openOnWed"] ? removeUTCOffset(values["wedFrom"]) : "",
      wedTo: values["openOnWed"] ? removeUTCOffset(values["wedTo"]) : "",
      thurFrom: values["openOnThur"] ? removeUTCOffset(values["thurFrom"]) : "",
      thurTo: values["openOnThur"] ? removeUTCOffset(values["thurTo"]) : "",
      friFrom: values["openOnFri"] ? removeUTCOffset(values["friFrom"]) : "",
      friTo: values["openOnFri"] ? removeUTCOffset(values["friTo"]) : "",
      satFrom: values["openOnSat"] ? removeUTCOffset(values["satFrom"]) : "",
      satTo: values["openOnSat"] ? removeUTCOffset(values["satTo"]) : "",
      sunFrom: values["openOnSun"] ? removeUTCOffset(values["sunFrom"]) : "",
      sunTo: values["openOnSun"] ? removeUTCOffset(values["sunTo"]) : "",
      openOnMon: values["openOnMon"],
      openOnTue: values["openOnTue"],
      openOnWed: values["openOnWed"],
      openOnThur: values["openOnThur"],
      openOnFri: values["openOnFri"],
      openOnSat: values["openOnSat"],
      openOnSun: values["openOnSun"],
      breakStartMon: values["openOnMon"] && values["breakStartMon"] ? removeUTCOffset(values["breakStartMon"]) : "",
      breakStartTue: values["openOnTue"] && values["breakStartTue"] ? removeUTCOffset(values["breakStartTue"]) : "",
      breakStartWed: values["openOnWed"] && values["breakStartWed"] ? removeUTCOffset(values["breakStartWed"]) : "",
      breakStartThu: values["openOnThur"] && values["breakStartThu"] ? removeUTCOffset(values["breakStartThu"]) : "",
      breakStartFri: values["openOnFri"] && values["breakStartFri"] ? removeUTCOffset(values["breakStartFri"]) : "",
      breakStartSat: values["openOnSat"] && values["breakStartSat"] ? removeUTCOffset(values["breakStartSat"]) : "",
      breakStartSun: values["openOnSun"] && values["breakStartSun"] ? removeUTCOffset(values["breakStartSun"]) : "",
      breakDurationMon: parseIntOrNull(values["breakDurationMon"]),
      breakDurationTue: parseIntOrNull(values["breakDurationTue"]),
      breakDurationWed: parseIntOrNull(values["breakDurationWed"]),
      breakDurationThu: parseIntOrNull(values["breakDurationThu"]),
      breakDurationFri: parseIntOrNull(values["breakDurationFri"]),
      breakDurationSat: parseIntOrNull(values["breakDurationSat"]),
      breakDurationSun: parseIntOrNull(values["breakDurationSun"]),
      maxBreakDelayMon: parseIntOrNull(values["maxBreakDelayMon"]),
      maxBreakDelayTue: parseIntOrNull(values["maxBreakDelayTue"]),
      maxBreakDelayWed: parseIntOrNull(values["maxBreakDelayWed"]),
      maxBreakDelayThu: parseIntOrNull(values["maxBreakDelayThu"]),
      maxBreakDelayFri: parseIntOrNull(values["maxBreakDelayFri"]),
      maxBreakDelaySat: parseIntOrNull(values["maxBreakDelaySat"]),
      maxBreakDelaySun: parseIntOrNull(values["maxBreakDelaySun"]),
      pickupLeadTime: parseInt(values["pickupLeadTime"]),
      dropoffLeadTime: parseInt(values["dropoffLeadTime"]),
      adhocReminder: parseInt(values["adhocReminder"]),
      transfersPerDayYellowAlert: Number(values["transfersPerDayYellowAlert"]),
      transfersPerDayRedAlert: Number(values["transfersPerDayRedAlert"]),
      percentMultiloadYellowAlert: Number(values["percentMultiloadYellowAlert"]),
      percentMultiloadRedAlert: Number(values["percentMultiloadRedAlert"]),
      transfersPerHourYellowAlert: Number(values["transfersPerHourYellowAlert"]),
      transfersPerHourRedAlert: Number(values["transfersPerHourRedAlert"]),
      kmPerTransferYellowAlert: Number(values["kmPerTransferYellowAlert"]),
      kmPerTransferRedAlert: Number(values["kmPerTransferRedAlert"]),
      isEnabled: isEnabled,
      bookingConfirmation: values["bookingConfirmation"] == "true" ? true : false,
      isAgedCare: Boolean(values["isAgedCare"]),
      isEventMedical: Boolean(values["isEventMedical"]),
      isSMABase: Boolean(values["isSMABase"]),
      isPatientTransport: Boolean(values["isPatientTransport"]),
      clusterId: values["clusterId"] == "" ? null : values["clusterId"],
      timeToAcknowledgeYellowAlert: Number(values["timeToAcknowledgeYellowAlert"]),
      timeToAcknowledgeRedAlert: Number(values["timeToAcknowledgeRedAlert"]),
      timeToAttendYellowAlert: Number(values["timeToAttendYellowAlert"]),
      timeToAttendRedAlert: Number(values["timeToAttendRedAlert"]),
      calloutsNPSSurveyYellowAlert: Number(values["calloutsNPSSurveyYellowAlert"]),
      calloutsNPSSurveyRedAlert: Number(values["calloutsNPSSurveyRedAlert"]),
      calloutsPerDayYellowAlert: Number(values["calloutsPerDayYellowAlert"]),
      calloutsPerDayRedAlert: Number(values["calloutsPerDayRedAlert"]),
      isPublicHoliday: Boolean(values["isPublicHoliday"]),
      code1AcceptableValue :values["code1AcceptableValue"],
      code2AcceptableValue :values["code2AcceptableValue"],
      code3AcceptableValue :values["code3AcceptableValue"],
      code4AcceptableValue :values["code4AcceptableValue"],   
    };
    try {
      const billingValidation = checkBillingValues();
      if (billingValidation.isError) {
        setErrorMessage(billingValidation.errMessage ?? "");
        setLoading(false);
        return;
      }
    if (validatePlannersShiftHours(planners)){
        const requestResponse = await api.updateLocation("", addOtherValuesToRequest(_req));        
        if (!requestResponse.hasError && requestResponse.message !== null) setStatusMessage(requestResponse.message);
        else {
          setErrorMessage(requestResponse.message);
        }
        setLoading(false);
      }
      else {
        setLoading(false);
      }
    } catch (error) {
      //setErrorMessage(error);
      setLoading(false);  
  };
}

  const deleteItem = async (): Promise<void> => {
    setLoading(true);
    setConfirmationDialog(false);
    setErrorMessage("");
    setStatusMessage("");
    let values = getValues();
    let _req: { [index: string]: any } = {
      locationId: editItemId,
      name: values["name"],
      shortName: values["shortName"],
      customerId: values["customerId"] == "" ? null : values["customerId"],
      geoName: googlePlaceDetails?.name,
      streetAddress: googlePlaceDetails?.address_details?.home,
      suburb: googlePlaceDetails?.address_details?.city,
      state: googlePlaceDetails?.address_details?.region,
      postcode: googlePlaceDetails?.address_details?.postal_code,
      longitude: googlePlaceDetails?.lng,
      latitude: googlePlaceDetails?.lat,
      googlePlaceId: values["googlePlaceId"],
      monFrom: values["openOnMon"] ? removeUTCOffset(values["monFrom"]) : "",
      monTo: values["openOnMon"] ? removeUTCOffset(values["monTo"]) : "",
      tueFrom: values["openOnTue"] ? removeUTCOffset(values["tueFrom"]) : "",
      tueTo: values["openOnTue"] ? removeUTCOffset(values["tueTo"]) : "",
      wedFrom: values["openOnWed"] ? removeUTCOffset(values["wedFrom"]) : "",
      wedTo: values["openOnWed"] ? removeUTCOffset(values["wedTo"]) : "",
      thurFrom: values["openOnThur"] ? removeUTCOffset(values["thurFrom"]) : "",
      thurTo: values["openOnThur"] ? removeUTCOffset(values["thurTo"]) : "",
      friFrom: values["openOnFri"] ? removeUTCOffset(values["friFrom"]) : "",
      friTo: values["openOnFri"] ? removeUTCOffset(values["friTo"]) : "",
      satFrom: values["openOnSat"] ? removeUTCOffset(values["satFrom"]) : "",
      satTo: values["openOnSat"] ? removeUTCOffset(values["satTo"]) : "",
      sunFrom: values["openOnSun"] ? removeUTCOffset(values["sunFrom"]) : "",
      sunTo: values["openOnSun"] ? removeUTCOffset(values["sunTo"]) : "",
      openOnMon: values["openOnMon"],
      openOnTue: values["openOnTue"],
      openOnWed: values["openOnWed"],
      openOnThur: values["openOnThur"],
      openOnFri: values["openOnFri"],
      openOnSat: values["openOnSat"],
      openOnSun: values["openOnSun"],
      pickupLeadTime: parseInt(values["pickupLeadTime"]),
      dropoffLeadTime: parseInt(values["dropoffLeadTime"]),
      adhocReminder: parseInt(values["adhocReminder"]),
      isEnabled: isEnabled,
      isAgedCare: Boolean(values["isAgedCare"]),
      isEventMedical: Boolean(values["isEventMedical"]),
      isSMABase: Boolean(values["isSMABase"]),
      isPatientTransport: Boolean(values["isPatientTransport"]),
      clusterId: values["clusterId"] == "" ? null : values["clusterId"],
      deleted: true,
      isPublicHoliday: Boolean(values["isPublicHoliday"]),
      code1AcceptableValue :values["code1AcceptableValue"],
      code2AcceptableValue :values["code2AcceptableValue"],
      code3AcceptableValue :values["code3AcceptableValue"],
      code4AcceptableValue :values["code4AcceptableValue"],
    };

        try {
            const requestResponse = await api.updateLocation("", _req);
            if (!requestResponse.hasError && requestResponse.message !== null) backToList();
            else {
                setErrorMessage(requestResponse.message);
                window.scrollTo({ top: document.body.scrollHeight, behavior: "smooth" });
            }
            setLoading(false);
        } catch (error) {
            setErrorMessage("");
            setLoading(false);
            window.scrollTo({ top: document.body.scrollHeight, behavior: "smooth" });
        }
    };

    //#endregion

    //#region Handle element state changes
    const handleSetBillingValuesObj = (name: string, value: string | null | any) => {
        setBillingValuesObj((prevState) => ({
            ...prevState,
            [name]: value,
        }));
    };

  const selectChangedHandler = (value: any, filedName: string) => {
    if (filedName == "customerId")
    {
      setValue("customerId", value);
      getAddItemData(value);
    } 

        if (filedName == "bookingConfirmation") setValue("bookingConfirmation", value);
    };


  const selectChangedHandlerLocationcode = (value: any, filedName: string) => {
      setValue(filedName, value);
  };

  const handleOpen = () => {
    setOpen(true);
    resetMessages();
  };

    const handleClose = () => {
        setOpen(false);
        resetMessages();
    };

    const backToList = () => {
        history.push({
            pathname: "/settings/locations",
        });
    };

    const resetMessages = () => {
        setErrorMessage("");
        setStatusMessage("");
    };
    //#endregion

    //#region Other Components
    const StarIcon = () => {
        return (
            <svg xmlns="http://www.w3.org/2000/svg" width="11" height="10" viewBox="0 0 11 10" style={{ marginRight: 5 }}>
                <path
                    id="_copy"
                    data-name="* copy"
                    d="M7.961,10,9.444,8.9,7.056,5.658,11,4.306,10.276,2.6,6.4,4.021V0H4.487V4.021L.651,2.6,0,4.306,3.836,5.658,1.484,8.9,3.112,10,5.464,6.584Z"
                    fill="#f4b827"
                />
            </svg>
        );
    };

    const ArrowIcon = (props: any) => {
        return (
            <SvgIcon style={{ height: 20, width: 20 }}>
                <path
                    d="M6.293,13.707l-6-6L.257,7.67h0L.242,7.652.235,7.644.226,7.634.217,7.622.212,7.615.2,7.6l0,0L.186,7.581l0,0L.172,7.56l0,0L.158,7.54l0,0L.146,7.52l0,0L.134,7.5l0-.005L.122,7.48l0-.008L.112,7.46.106,7.449l0-.009L.094,7.424l0,0L.083,7.4h0a1,1,0,0,1,0-.8v0l.008-.017,0-.009L.1,6.562l.007-.014,0-.006a1,1,0,0,1,.182-.25l6-6A1,1,0,0,1,7.707,1.707L3.414,6H17a1,1,0,0,1,0,2H3.414l4.293,4.293a1,1,0,1,1-1.414,1.414Z"
                    fill="#02489D"
                />
            </SvgIcon>
        );
    };

    const HorizontalLine = (props: any) => {
        return (
            <hr
                style={{
                    height: 0,
                    borderTop: "1px solid #979797",
                }}
            />
        );
    };

    const CreateLoadingLine = (props: any): JSX.Element => {
        return (
            <div className={classes.loading}>
                <LinearProgress color="primary" />
            </div>
        );
    };

  const chooseBillingForm = () => {
    switch (billingType) {
      case "1":
        return (
          <BillingFormType1
            disabled={!props.authStore.data?.IsAdmin}
            billingValuesObj={billingValuesObj}
            handleSetBillingValuesObj={handleSetBillingValuesObj}
            retainerIntervals={billingRetainerIntervals}
         
          />
        );
      case "2":
        return (
          <BillingFormType2
            disabled={!props.authStore.data?.IsAdmin}
            billingValuesObj={billingValuesObj}
            handleSetBillingValuesObj={handleSetBillingValuesObj}
            retainerIntervals={billingRetainerIntervals}
          
          />
        );
      case "3":
        return (
          <BillingFormType3
            disabled={!props.authStore.data?.IsAdmin}
            billingValuesObj={billingValuesObj}
            handleSetBillingValuesObj={handleSetBillingValuesObj}
            cancellationIntervals={billingCancellationIntervals}
            retainerIntervals={billingRetainerIntervals}
            
          />
        );
      case "4":
        return (
          <BillingFormType4
            disabled={!props.authStore.data?.IsAdmin}
            billingValuesObj={billingValuesObj}
            handleSetBillingValuesObj={handleSetBillingValuesObj}
            retainerIntervals={billingRetainerIntervals}
           
          />
        );
      case "5":
        return (
          <BillingFormType5
            disabled={!props.authStore.data?.IsAdmin}
            billingValuesObj={billingValuesObj}
            handleSetBillingValuesObj={handleSetBillingValuesObj}
            retainerIntervals={billingRetainerIntervals}
            CheckDecisionRule={CheckDecisionRule}
            checkRules={checkRules}
            errormessage={errorMessageBilling}
          />
        );
      default:
        return null;
    }
  };

  const handleValidation = (e:any) => {
    const reg = new RegExp("[a-z]");
    setValid(reg.test(e.target.value));
  };
  const CheckDecisionRule = () => {
    setLoading(true);
    setErrorMessageBilling("")
    setcheckRules("");
    if (billingValuesObj.billingRuleID === null || billingValuesObj.billingRuleID === "") {
      setErrorMessageBilling("Billing Rule  cannot be empty")
      setLoading(false);
      return
    }
    else {
      setErrorMessageBilling("")
    }
    if (billingValuesObj.billingRuleID !== "") {
      if (billingValuesObj.billingRuleID?.trim() === "") {
        setErrorMessageBilling("Billing Rule cannot be empty")
        setLoading(false);
        return
      }
    }
    if (billingValuesObj.billingRuleID) {
      const res = api.checkRules('ruleName=' + billingValuesObj.billingRuleID + '&version=' + billingValuesObj.billingRuleVersion);
      res.then(res => {
        if (res.hasError) {
          setcheckRules("Test not succeeded");
          setLoading(false);
        }
        else {
          setcheckRules("Test succeeded");
          setLoading(false);
        }
      });
    }
  };
  //#endregion
  return (
    <React.Fragment>
      <div style={{ display: "flex", alignItems: "stretch", flexGrow: 1 }}>
        <div style={{ alignSelf: "stretch", display: "flex" }}>
          <SecondaryMenu selectedmenu="Locations" />
        </div>

                <div style={{ display: "flex", alignSelf: "start", width: "100%" }}>
                    <form onSubmit={handleSubmit(editItem ? updateItem : addNewItem)} autoComplete="off" id="itemForm">
                        <Grid className={classes.mainGrid} container spacing={3}>
                            <Grid item xs={12}>
                                <div className={classes.mainTop}>
                                    <IconButton className={classes.removeHover} onClick={backToList} aria-label="delete" size="small" style={{ fontFamily: "Lato" }}>
                                        <ArrowIcon />
                                        <span className="backBtn">{headingText}</span>
                                    </IconButton>
                                    {editItem ? (
                                        <Button className={classes.deleteBtn} variant="contained" onClick={() => setConfirmationDialog(true)}>
                                            Delete
                                        </Button>
                                    ) : null}
                                </div>
                            </Grid>
                            <Grid item xs={12}>
                                <div className={classes.main}>
                                    <div className={classes.heading}>{mainHeadingText}</div>
                                </div>
                            </Grid>
                            <Grid container item spacing={3} lg={5} alignContent="flex-start">
                                <Grid item xs={12}>
                                    <div className={classes.textFieldLable}>
                                        <StarIcon />
                                        NAME
                                    </div>
                                    <Controller
                                        control={control}
                                        as={
                                            <TextField
                                                classes={{ root: classes.textFieldRoot }}
                                                InputProps={{ classes: { root: classes.textFieldInput } }}
                                                variant="outlined"
                                                error={errors.name}
                                                helperText={errors.name ? errors.name.message : ""}
                                            />
                                        }
                                        rules={{
                                            required: "Name is required",
                                        }}
                                        name="name"
                                        defaultValue=""
                                    />
                                </Grid>

                                <Grid item xs={12}>
                                    <div className={classes.textFieldLable}>
                                        <StarIcon />
                                        LOCATION
                                    </div>
                                    <Controller
                                        name="googlePlaceId"
                                        defaultValue=""
                                        control={control}
                                        render={({ onChange, onBlur, value, name }) => (
                                            <GooglePlaceAutoComplete
                                                placeholder="Location name or address"
                                                onChange={(value: any) => {
                                                    setgooglePlaceDetails(value);
                                                    //value?.name ? setValue("geoName", value.name) : setValue("geoName", null);
                                                    //value?.address_details?.home ? setValue("streetAddress", value.address_details.home) : setValue("streetAddress", null);
                                                    //value?.address_details?.city ? setValue("suburb", value.address_details.city) : setValue("suburb", null);
                                                    //value?.address_details?.region ? setValue("state", value.address_details.region) : setValue("state", null);
                                                    //value?.address_details?.postal_code ? setValue("postcode", value.address_details.postal_code) : setValue("postcode", null);
                                                    if (value) {
                                                        onChange(value.place_id);
                                                    }
                                                }}
                                                value={value}
                                                name={name}
                                                onBlur={onBlur}
                                                error={errors.googlePlaceId}
                                                errorMessage={errors.googlePlaceId ? errors.googlePlaceId.message : ""}
                                            />
                                        )}
                                        rules={{
                                            validate: (value) => {
                                                if (!value === null || !googlePlaceDetails) {
                                                    return "Location is required";
                                                }
                                            },
                                        }}
                                    />
                                </Grid>

                                <Grid container item spacing={3} xs={12} className={classes.grid}>
                                    <Grid item xs={8}>
                                        <div className={classes.textFieldLable}>
                                            <StarIcon />
                                            SHORTNAME
                                        </div>
                                        <Controller
                                            control={control}
                                            as={
                                                <TextField
                                                    classes={{ root: classes.textFieldRoot }}
                                                    InputProps={{ classes: { root: classes.textFieldInput } }}
                                                    variant="outlined"
                                                    error={errors.shortName}
                                                    helperText={errors.shortName ? errors.shortName.message : ""}
                                                />
                                            }
                                            rules={{
                                                required: "Short name is required",
                                                maxLength: {
                                                    value: 20,
                                                    message: "Max length is 20",
                                                },
                                            }}
                                            defaultValue=""
                                            name="shortName"
                                        />
                                    </Grid>
                                    <Grid item xs={4} style={{ alignSelf: "center", textAlign: "center" }}>
                                        Max 20 chars
                                    </Grid>
                                </Grid>

                {/* -Customer- */}

                <Grid item xs={12}>
                  <div className={classes.textFieldLable}>
                    <StarIcon />
                    CUSTOMER
                  </div>
                  <Controller
                    name="customerId"
                    defaultValue=""
                    rules={{
                      required: "Customer is required",
                    }}
                    control={control}
                    render={({ onChange, onBlur, value, name }) => (
                      <React.Fragment>
                        <Select
                          error={errors.customerId}
                          onChange={(e) => selectChangedHandler(e.target.value, "customerId")}
                          className={classes.selectField}
                          fullWidth={true}
                          value={value}
                          IconComponent={KeyboardArrowDownIcon}
                          displayEmpty
                          defaultValue=""
                          variant="outlined"
                        >
                          <MenuItem key="None" value={""}>
                            Choose
                          </MenuItem>
                          {editItem
                            ? customerList
                              .filter((c) => c.disabled == false || c.value == value)
                              .map((item) => (
                                <MenuItem
                                  disabled={item.disabled}
                                  selected={item.selected}
                                  key={item.value}
                                  defaultValue={item.value}
                                  value={item.value}
                                >
                                  {item.text}
                                </MenuItem>
                              ))
                            : customerList
                              .filter((c) => c.disabled == false)
                              .map((item) => (
                                <MenuItem selected={item.selected} key={item.value} defaultValue={item.value} value={item.value}>
                                  {item.text}
                                </MenuItem>
                              ))}
                        </Select>
                        <FormHelperText className={classes.helpText}>{errors.customerId ? errors.customerId.message : ""}</FormHelperText>
                      </React.Fragment>
                    )}
                  />
                </Grid>

                                <Grid item xs={12}>
                                    <div className={classes.textFieldLable}>
                                        <StarIcon />
                                        SERVICES PROVIDED
                                    </div>
                                    <Controller
                                        name="isPatientTransport"
                                        control={control}
                                        defaultValue={false}
                                        render={({ value, name }) => (
                                            <FormControlLabel
                                                control={
                                                    <Checkbox
                                                        name={name}
                                                        style={{ padding: 4 }}
                                                        checked={value === true}
                                                        onChange={(e: React.ChangeEvent<any>) => {
                                                            const value = e.target.checked;
                                                            setValue(name, value);
                                                            updateDependentComponentState(name, value);
                                                        }}
                                                    />
                                                }
                                                label="Patient Transport"
                                            />
                                        )}
                                    />
                                    <Controller
                                        name="clusterId"
                                        defaultValue=""
                                        control={control}
                                        render={({ name, value }) => (
                                            <>
                                                <Select
                                                    error={errors.cluster}
                                                    onChange={(e) => setValue(name, e.target.value)}
                                                    className={classes.clusterSelectField}
                                                    fullWidth={true}
                                                    value={value}
                                                    displayEmpty
                                                    IconComponent={KeyboardArrowDownIcon}
                                                    defaultValue=""
                                                    variant="outlined"
                                                >
                                                    <MenuItem key="None" value={""}>
                                                        Choose Cluster (optional)
                                                    </MenuItem>
                                                    {clusterList.map((item) => (
                                                        <MenuItem selected={item.selected} key={item.value} defaultValue={item.value} value={item.value}>
                                                            {item.text}
                                                        </MenuItem>
                                                    ))}
                                                </Select>
                                                <FormHelperText className={classes.helpText}>{errors.clusterId ? errors.clusterId.message : ""}</FormHelperText>
                                            </>
                                        )}
                                    />
                                    <div style={{ display: "block" }}>
                                        <Controller
                                            name="isAgedCare"
                                            control={control}
                                            defaultValue={false}
                                            render={({ value, name }) => (
                                                <FormControlLabel
                                                    control={
                                                        <Checkbox
                                                            name={name}
                                                            style={{ padding: 4 }}
                                                            checked={value === true}
                                                            onChange={(e: React.ChangeEvent<any>) => {
                                                                const value = e.target.checked;
                                                                setValue(name, value);
                                                                updateDependentComponentState(name, value);
                                                            }}
                                                        />
                                                    }
                                                    label="Medical Response"
                                                />
                                            )}
                                        />
                                    </div>
                                    <div style={{ display: "block" }}>
                                        <Controller
                                            name="isEventMedical"
                                            control={control}
                                            defaultValue={false}
                                            render={({ value, name }) => (
                                                <FormControlLabel
                                                    control={
                                                        <Checkbox
                                                            name={name}
                                                            style={{ padding: 4 }}
                                                            checked={value === true}
                                                            onChange={(e: React.ChangeEvent<any>) => setValue(name, e.target.checked)}
                                                        />
                                                    }
                                                    label="Event Medical"
                                                />
                                            )}
                                        />
                                    </div>
                                    <div style={{ display: "block" }}>
                                        <Controller
                                            name="isSMABase"
                                            control={control}
                                            defaultValue={false}
                                            render={({ value, name }) => (
                                                <FormControlLabel
                                                    control={
                                                        <Checkbox
                                                            name={name}
                                                            style={{ padding: 4 }}
                                                            checked={value === true}
                                                            onChange={(e: React.ChangeEvent<any>) => setValue(name, e.target.checked)}
                                                        />
                                                    }
                                                    label="SMA Base"
                                                />
                                            )}
                                        />
                                    </div>
                                </Grid>

                <Grid item xs={12}>
                  <div className={classes.textFieldLable}>
                    <StarIcon />
                    STATUS
                  </div>
                  <Controller
                    render={(props) => (
                      <RadioGroup row aria-label="position" name="Status" defaultValue="top">
                        <FormControlLabel
                          value="Enabled"
                          checked={isEnabled}
                          onChange={(e) => {
                            props.onChange(e);
                            setIsEnabled(true);
                          }}
                          control={<Radio color="primary" />}
                          label="Enabled"
                        />
                        <FormControlLabel
                          value="Disabled"
                          checked={!isEnabled}
                          onChange={(e) => {
                            props.onChange(e);
                            setIsEnabled(false);
                          }}
                          control={<Radio color="primary" />}
                          label="Disabled"
                        />
                      </RadioGroup>
                    )}
                    name="Status"
                    defaultValue=""
                    control={control}
                  />
                </Grid>


              </Grid>
              <Grid item lg={1}></Grid>
              <Grid container item spacing={1} lg={6} alignContent="flex-start">
                <Grid container item xs={12} spacing={3} style={{ marginTop: 20 }} className={classes.grid}>
                  <Grid item xs={12}>
                    <div className={classes.textFieldLable}>
                      <StarIcon />
                      SCHEDULING LEAD TIME
                    </div>
                  </Grid>
                  <Grid item xs={6}>
                    <span>Transfer must be scheduled at least ...</span>
                    <Controller
                      control={control}
                      as={
                        <TextField
                          InputProps={{
                            classes: { root: classes.textFieldInput },
                            endAdornment: <InputAdornment position="end">minutes</InputAdornment>,
                          }}
                          variant="outlined"
                          error={errors.pickupLeadTime}
                          type="number"
                        />
                      }
                      rules={{
                        required: "Pickup lead time is required",
                        pattern: {
                          value: /^[1-9]\d*$/,
                          message: "Only whole number is allowed",
                        },
                      }}
                      name="pickupLeadTime"
                      defaultValue=""
                    />
                    <span>... before pickup time</span>
                    <FormHelperText className={classes.helpText}>{errors.pickupLeadTime ? errors.pickupLeadTime.message : ""}</FormHelperText>
                  </Grid>
                  <Grid item xs={6}>
                    <span>Transfer must be scheduled at least ...</span>
                    <Controller
                      control={control}
                      as={
                        <TextField
                          InputProps={{
                            classes: { root: classes.textFieldInput },
                            endAdornment: <InputAdornment position="end">minutes</InputAdornment>,
                          }}
                          variant="outlined"
                          error={errors.dropoffLeadTime}
                          type="number"
                        />
                      }
                      rules={{
                        required: "Dropoff lead time is required",
                        pattern: {
                          value: /^[1-9]\d*$/,
                          message: "Only whole number is allowed",
                        },
                      }}
                      name="dropoffLeadTime"
                      defaultValue=""
                    />
                    <span>... before dropoff time</span>
                    <FormHelperText className={classes.helpText}>{errors.dropoffLeadTime ? errors.dropoffLeadTime.message : ""}</FormHelperText>
                  </Grid>
                  <Grid item xs={12}>
                    <div className={classes.textFieldLable}>
                      AD-HOC REMINDER DURATION (MINUTES)
                    </div>
                    <div className={classes.adhocSpan}><span>Set the number of minutes from a transfer being moved to ad-hoc that a reminder is issued if the transfer has not been scheduled yet.</span></div>
                    <Controller
                      control={control}
                      as={
                        <TextField 
                          InputProps={{
                            classes: { root: classes.adhocTextFieldInput },
                            endAdornment: <InputAdornment position="end">minutes</InputAdornment>,
                          }}
                          variant="outlined"
                          error={errors.pickupLeadTime}
                          type="number"
                        />
                      }
                      rules={{
                        pattern: {
                          value: /^[1-9]\d*$/,
                          message: "Only whole number is allowed",
                        },
                      }}
                      name="adhocReminder"
                      defaultValue={editItem?"":"60"}
                    />
                    <FormHelperText className={classes.helpText}>{errors.adhocReminder ? errors.adhocReminder.message : ""}</FormHelperText>
                  </Grid>
                </Grid>
              </Grid>

              {/* -Location Code- */}
              <Grid container item spacing={3} lg={5} alignContent="flex-start">
                {!IsNullOrEmpty(customerdetails.code1Label) && (<Grid item xs={12}>
                  <div className={classes.textFieldLable}>
                    {customerdetails.code1Label}
                  </div>
                  {code1AcceptableValues.length > 0 ? (<Controller
                    name="code1AcceptableValue"
                    defaultValue=""
                    control={control}
                    render={({ onChange, onBlur, value, name }) => (
                      <React.Fragment>
                        <Select
                          error={errors.code1AcceptableValue}
                          onChange={(e) => selectChangedHandlerLocationcode(e.target.value, "code1AcceptableValue")}
                          className={classes.selectField}
                          fullWidth={true}
                          value={value}
                          IconComponent={KeyboardArrowDownIcon}
                          displayEmpty
                          defaultValue=""
                          variant="outlined"
                        >
                          <MenuItem key="None" value={""}>
                            Choose
                          </MenuItem>
                          {code1AcceptableValues.length > 1
                            ? code1AcceptableValues
                              .filter((c) => c.disabled == false || c.value == value)
                              .map((item) => (
                                <MenuItem
                                  disabled={item.disabled}
                                  selected={item.selected}
                                  key={item.value}
                                  defaultValue={item.value}
                                  value={item.value}
                                >
                                  {item.text}
                                </MenuItem>
                              ))
                            : code1AcceptableValues
                              .filter((c) => c.disabled == false)
                              .map((item) => (
                                <MenuItem selected={item.selected} key={item.value} defaultValue={item.value} value={item.value}>
                                  {item.text}
                                </MenuItem>
                              ))}
                        </Select>
                      </React.Fragment>
                    )}
                  />
                  )
                    :
                    <Controller
                      control={control}
                      as={
                        <TextField
                          classes={{ root: classes.textFieldRoot }}
                          InputProps={{ classes: { root: classes.textFieldInput } }}
                          inputProps={{ maxLength: 100 }}
                          variant="outlined"
                          error={errors.code1AcceptableValue}
                          helperText={errors.code1AcceptableValue ? errors.code1AcceptableValue.message : ""}
                        />
                      }
                      name="code1AcceptableValue"
                      defaultValue=""
                      rules={{
                        pattern: {
                          value: consts.LocationcodeAcceptableValueRegex,
                          message: "Invalid " + (customerdetails.code1Label)
                        }
                      }}
                    />
                  }
                </Grid>)}
                {!IsNullOrEmpty(customerdetails.code3Label) && (<Grid item xs={12}>
                  <div className={classes.textFieldLable}>
                    {customerdetails.code3Label}
                  </div>
                  {code3AcceptableValues.length > 0 ? (<Controller
                    name="code3AcceptableValue"
                    defaultValue=""
                    control={control}
                    render={({ onChange, onBlur, value, name }) => (
                      <React.Fragment>
                        <Select
                          error={errors.code3AcceptableValue}
                          onChange={(e) => selectChangedHandlerLocationcode(e.target.value, "code3AcceptableValue")}
                          className={classes.selectField}
                          fullWidth={true}
                          value={value}
                          IconComponent={KeyboardArrowDownIcon}
                          displayEmpty
                          defaultValue=""
                          variant="outlined"
                        >
                          <MenuItem key="None" value={""}>
                            Choose
                          </MenuItem>
                          {code3AcceptableValues.length > 0
                            ? code3AcceptableValues
                              .filter((c) => c.disabled == false || c.value == value)
                              .map((item) => (
                                <MenuItem
                                  disabled={item.disabled}
                                  selected={item.selected}
                                  key={item.value}
                                  defaultValue={item.value}
                                  value={item.value}
                                >
                                  {item.text}
                                </MenuItem>
                              ))
                            : code3AcceptableValues
                              .filter((c) => c.disabled == false)
                              .map((item) => (
                                <MenuItem selected={item.selected} key={item.value} defaultValue={item.value} value={item.value}>
                                  {item.text}
                                </MenuItem>
                              ))}
                        </Select>
                      </React.Fragment>
                    )}
                  />)
                    :
                    <Controller
                      control={control}
                      as={
                        <TextField
                          classes={{ root: classes.textFieldRoot }}
                          InputProps={{ classes: { root: classes.textFieldInput } }}
                          inputProps={{ maxLength: 100 }}
                          onChange={(e) => handleValidation(e)}
                          variant="outlined"
                          error={errors.code3AcceptableValue}
                          helperText={errors.code3AcceptableValue ? errors.code3AcceptableValue.message : ""}
                        />
                      }
                      name="code3AcceptableValue"
                      defaultValue=""
                      rules={{
                        pattern: {
                          value: consts.LocationcodeAcceptableValueRegex,
                          message: "Invalid " + (customerdetails.code3Label)
                        }
                      }}
                    />
                  }
                </Grid>)}
              </Grid>
              <Grid item lg={1}></Grid>
              <Grid container item spacing={3} lg={5} alignContent="flex-start">
                {!IsNullOrEmpty(customerdetails.code2Label) && (<Grid item xs={12}>
                  <div className={classes.textFieldLable}>
                    {customerdetails.code2Label}
                  </div>
                  {code2AcceptableValues.length > 0 ? (<Controller
                    name="code2AcceptableValue"
                    defaultValue=""
                    control={control}
                    render={({ onChange, onBlur, value, name }) => (
                      <React.Fragment>
                        <Select
                          error={errors.code2AcceptableValue}
                          onChange={(e) => selectChangedHandlerLocationcode(e.target.value, "code2AcceptableValue")}
                          className={classes.selectField}
                          fullWidth={true}
                          value={value}
                          IconComponent={KeyboardArrowDownIcon}
                          displayEmpty
                          defaultValue=""
                          variant="outlined"
                        >
                          <MenuItem key="None" value={""}>
                            Choose
                          </MenuItem>
                          {code2AcceptableValues.length > 0
                            ? code2AcceptableValues
                              .filter((c) => c.disabled == false || c.value == value)
                              .map((item) => (
                                <MenuItem
                                  disabled={item.disabled}
                                  selected={item.selected}
                                  key={item.value}
                                  defaultValue={item.value}
                                  value={item.value}
                                >
                                  {item.text}
                                </MenuItem>
                              ))
                            : code2AcceptableValues
                              .filter((c) => c.disabled == false)
                              .map((item) => (
                                <MenuItem selected={item.selected} key={item.value} defaultValue={item.value} value={item.value}>
                                  {item.text}
                                </MenuItem>
                              ))}
                        </Select>
                      </React.Fragment>
                    )}
                  />)
                    :
                    <Controller
                      control={control}
                      as={
                        <TextField
                          classes={{ root: classes.textFieldRoot }}
                          InputProps={{ classes: { root: classes.textFieldInput } }}
                          inputProps={{ maxLength: 100 }}
                          variant="outlined"
                          error={errors.code2AcceptableValue}
                          helperText={errors.code2AcceptableValue ? errors.code2AcceptableValue.message : ""}
                        />
                      }
                      name="code2AcceptableValue"
                      defaultValue=""
                      rules={{
                        pattern: {
                          value: consts.LocationcodeAcceptableValueRegex,
                          message: "Invalid " + (customerdetails.code2Label)
                        }
                      }}
                    />
                  }
                </Grid>)}
                {!IsNullOrEmpty(customerdetails.code4Label) && (<Grid item xs={12}>
                  <div className={classes.textFieldLable}>
                    {customerdetails.code4Label}
                  </div>
                  {code4AcceptableValues.length > 0 ? (<Controller
                    name="code4AcceptableValue"
                    defaultValue=""
                    control={control}
                    render={({ onChange, onBlur, value, name }) => (
                      <React.Fragment>
                        <Select
                          error={errors.code4AcceptableValue}
                          onChange={(e) => selectChangedHandlerLocationcode(e.target.value, "code4AcceptableValue")}
                          className={classes.selectField}
                          fullWidth={true}
                          value={value}
                          IconComponent={KeyboardArrowDownIcon}
                          displayEmpty
                          defaultValue=""
                          variant="outlined"
                        >
                          <MenuItem key="None" value={""}>
                            Choose
                          </MenuItem>
                          {code4AcceptableValues.length > 0
                            ? code4AcceptableValues
                              .filter((c) => c.disabled == false || c.value == value)
                              .map((item) => (
                                <MenuItem
                                  disabled={item.disabled}
                                  selected={item.selected}
                                  key={item.value}
                                  defaultValue={item.value}
                                  value={item.value}
                                >
                                  {item.text}
                                </MenuItem>
                              ))
                            : code4AcceptableValues
                              .filter((c) => c.disabled == false)
                              .map((item) => (
                                <MenuItem selected={item.selected} key={item.value} defaultValue={item.value} value={item.value}>
                                  {item.text}
                                </MenuItem>
                              ))}
                        </Select>
                      </React.Fragment>
                    )}
                  />)
                    :
                    <Controller
                      control={control}
                      as={
                        <TextField
                          classes={{ root: classes.textFieldRoot }}
                          InputProps={{ classes: { root: classes.textFieldInput } }}
                          inputProps={{ maxLength: 100 }}
                          variant="outlined"
                          error={errors.code4AcceptableValue}
                          helperText={errors.code4AcceptableValue ? errors.code4AcceptableValue.message : ""}
                        />
                      }
                      name="code4AcceptableValue"
                      defaultValue=""
                      rules={{
                        pattern: {
                          value: consts.LocationcodeAcceptableValueRegex,
                          message: "Invalid " + (customerdetails.code4Label)
                        }
                      }}
                    />
                  }
                </Grid>)}
              </Grid>

              <PatientTransportKPI parentClasses={classes} StarIcon={StarIcon} control={control} isItVisible={isPatientTransportVisible} />
              <AgedCareKPI parentClasses={classes} StarIcon={StarIcon} control={control} isItVisible={isAgedCareVisible} />
              <Grid container item xs={8} style={{ marginTop: 20 }}>
                <Grid item xs={12}>
                  <div style={{ fontSize: 20, fontWeight: 900 }}>Notification Settings</div>
                </Grid>

                                <Grid container item xs={12} style={{ marginTop: 20, border: "1px solid black", borderRadius: "5px" }}>
                                    <Grid item xs={11}>
                                        <div style={{ display: "inline", float: "left" }}>
                                            <MailOutlineIcon style={{ padding: 5 }} />
                                        </div>
                                        <div style={{ padding: 10, fontWeight: 800, display: "inline", float: "left" }}>Booking Confirmation</div>
                                    </Grid>

                                    <Grid item xs={1}>
                                        <div style={{ display: "inline", float: "right", margin: "2px" }}>
                                            <Controller
                                                name="bookingConfirmation"
                                                defaultValue="On"
                                                control={control}
                                                render={({ onChange, onBlur, value, name }) => (
                                                    <Select
                                                        onChange={(e) => selectChangedHandler(e.target.value, "bookingConfirmation")}
                                                        className={classes.selectField}
                                                        value={value}
                                                        IconComponent={KeyboardArrowDownIcon}
                                                        variant="outlined"
                                                    >
                                                        <MenuItem key="On" value="true">
                                                            <a style={{ paddingRight: 5 }}>On</a>
                                                        </MenuItem>
                                                        <MenuItem key="Off" value="false">
                                                            <a style={{ paddingRight: 5 }}>Off</a>
                                                        </MenuItem>
                                                    </Select>
                                                )}
                                            />
                                        </div>
                                    </Grid>
                                </Grid>
                            </Grid>
                            <Grid item xs={12}>
                                <p style={{ fontSize: 20, fontWeight: 900 }}>Billing</p>
                                <p style={{ fontSize: 18 }}>All amounts exclusive of GST</p>
                            </Grid>
                            <Grid item xs={12}>
                                <BillingTypeSelect
                                    parentClasses={classes}
                                    setBillingType={setBillingType}
                                    billingType={billingType}
                                    billingTypes={billingTypes}
                                    disabled={!props.authStore.data?.IsAdmin}
                                />
                            </Grid>
                            <Grid container item xs={12}>
                                {chooseBillingForm()}
                            </Grid>

                            <Grid container item xs={12} spacing={3} className={classes.grid}>
                                <Grid item xs={12} style={{ fontSize: 19, fontWeight: 700 }}>
                                    Hours of Service
                                    <div className="checkbox-sec">
                                        <Controller
                                            name="isPublicHoliday"
                                            control={control}
                                            defaultValue={false}
                                            render={({ value, name }) => (
                                                <FormControlLabel
                                                    control={
                                                        <Checkbox
                                                            name={name}
                                                            checked={value === true}
                                                            style={{ padding: 0, marginRight: 5 }}
                                                            //checked={billingValuesObj.isPrimaryHospital}
                                                            onChange={(e: React.ChangeEvent<any>) => { setValue(name, e.target.checked); }}
                                                        />
                                                    }
                                                    label="Closed on public holidays"
                                                />
                                            )}
                                        />
                                    </div>
                                </Grid>
                                <Grid container item xs={12} spacing={3} className={classes.grid}>
                                    <Grid container item xs={12} spacing={1}>
                                        <Grid item xs={6} lg={5}></Grid>
                                        <Grid item xs={6} lg={3}></Grid>
                                        <Grid item xs={6} lg={2}>
                                            <div className={classes.textFieldLabel}>
                                                From
                                            </div>
                                        </Grid>
                                        <Grid item xs={6} lg={2}>
                                            <div className={classes.textFieldLabel}>
                                                To
                                            </div>
                                        </Grid>
                                    </Grid>
                                </Grid>
                                <Grid container item xs={12} spacing={3} className={classes.grid}>
                                    <AddEditLocationHoursRow
                                        hd="Monday"
                                        errorsFrom={errors.monFrom}
                                        nameFrom="monFrom"
                                        setFromValue={(value: MaterialUiPickersDate | null) => {
                                            setValue("monFrom", value);
                                        }}
                                        errorsTo={errors.monTo}
                                        nameTo="monTo"
                                        setToValue={(value: MaterialUiPickersDate | null) => {
                                            setValue("monTo", value);
                                        }}
                                        businessOpenName="openOnMon"
                                        businessOpenValue={watch("openOnMon", true)}
                                        control={control}
                                    />
                                    <AddEditLocationHoursRow
                                        hd="Tuesday"
                                        errorsFrom={errors.tueFrom}
                                        nameFrom="tueFrom"
                                        setFromValue={(value: MaterialUiPickersDate | null) => {
                                            setValue("tueFrom", value);
                                        }}
                                        errorsTo={errors.tueTo}
                                        nameTo="tueTo"
                                        setToValue={(value: MaterialUiPickersDate | null) => {
                                            setValue("tueTo", value);
                                        }}
                                        businessOpenName="openOnTue"
                                        businessOpenValue={watch("openOnTue", true)}
                                        control={control}
                                    />
                                    <AddEditLocationHoursRow
                                        hd="Wednesday"
                                        errorsFrom={errors.wedFrom}
                                        nameFrom="wedFrom"
                                        setFromValue={(value: MaterialUiPickersDate | null) => {
                                            setValue("wedFrom", value);
                                        }}
                                        errorsTo={errors.wedTo}
                                        nameTo="wedTo"
                                        setToValue={(value: MaterialUiPickersDate | null) => {
                                            setValue("wedTo", value);
                                        }}
                                        businessOpenName="openOnWed"
                                        businessOpenValue={watch("openOnWed", true)}
                                        control={control}
                                    />
                                    <AddEditLocationHoursRow
                                        hd="Thursday"
                                        errorsFrom={errors.thurFrom}
                                        nameFrom="thurFrom"
                                        setFromValue={(value: MaterialUiPickersDate | null) => {
                                            setValue("thurFrom", value);
                                        }}
                                        errorsTo={errors.thurTo}
                                        nameTo="thurTo"
                                        setToValue={(value: MaterialUiPickersDate | null) => {
                                            setValue("thurTo", value);
                                        }}
                                        businessOpenName="openOnThur"
                                        businessOpenValue={watch("openOnThur", true)}
                                        control={control}
                                    />
                                    <AddEditLocationHoursRow
                                        hd="Friday"
                                        errorsFrom={errors.friFrom}
                                        nameFrom="friFrom"
                                        setFromValue={(value: MaterialUiPickersDate | null) => {
                                            setValue("friFrom", value);
                                        }}
                                        errorsTo={errors.friTo}
                                        nameTo="friTo"
                                        setToValue={(value: MaterialUiPickersDate | null) => {
                                            setValue("friTo", value);
                                        }}
                                        businessOpenName="openOnFri"
                                        businessOpenValue={watch("openOnFri", true)}
                                        control={control}
                                    />
                                    <AddEditLocationHoursRow
                                        hd="Saturday"
                                        errorsFrom={errors.satFrom}
                                        nameFrom="satFrom"
                                        setFromValue={(value: MaterialUiPickersDate | null) => {
                                            setValue("satFrom", value);
                                        }}
                                        errorsTo={errors.satTo}
                                        nameTo="satTo"
                                        setToValue={(value: MaterialUiPickersDate | null) => {
                                            setValue("satTo", value);
                                        }}
                                        businessOpenName="openOnSat"
                                        businessOpenValue={watch("openOnSat", true)}
                                        control={control}
                                    />
                                    <AddEditLocationHoursRow
                                        hd="Sunday"
                                        errorsFrom={errors.sunFrom}
                                        nameFrom="sunFrom"
                                        setFromValue={(value: MaterialUiPickersDate | null) => {
                                            setValue("sunFrom", value);
                                        }}
                                        errorsTo={errors.sunTo}
                                        nameTo="sunTo"
                                        setToValue={(value: MaterialUiPickersDate | null) => {
                                            setValue("sunTo", value);
                                        }}
                                        businessOpenName="openOnSun"
                                        businessOpenValue={watch("openOnSun", true)}
                                        control={control}
                                    />
                                </Grid>
                            </Grid>

                            <Grid item xs={12} style={{ fontSize: 19, fontWeight: 700 }}>
                                Planners
                            </Grid>
                            <div style={{ fontSize: 15, fontWeight: 400, color: "#949494", padding: "0px 12px" }}>{plannerSectionDescription}</div>
                            <Grid container item xs={12}>
                                <ListPlanners planners={planners} getEditItemData={getEditItemDatapopup} setPlanners={setPlanners} locationid={editItemId} />
                            </Grid>
                        </Grid>

                        <div>
                            <div className={classes.main} style={{ paddingLeft: 40, paddingRight: 40 }}>
                                <div className={classes.headingAlert}>
                                    <Alert
                                        variant="filled"
                                        icon={<ReportProblemOutlinedIcon />}
                                        severity="error"
                                        classes={{ root: classes.alertRoot }}
                                        style={{ display: errorMessage ? "flex" : "none" }}
                                    >
                                        {errorMessage}
                                    </Alert>
                                    <Alert
                                        variant="filled"
                                        icon={<InfoIcon />}
                                        severity="success"
                                        classes={{ root: classes.alertRoot }}
                                        style={{ display: statusMessage ? "flex" : "none" }}
                                    >
                                        {statusMessage}
                                    </Alert>
                                </div>
                            </div>

                            <div>{loading ? <CreateLoadingLine /> : <HorizontalLine />}</div>

                            <div className={classes.formLeft}>
                                <Button disabled={formState.isSubmitting} tabIndex={1000} className={classes.formBtn} variant="contained" color="primary" type="submit">
                                    Save
                                </Button>
                                <Button className={classes.formBtn} tabIndex={1001} variant="contained" onClick={backToList}>
                                    Cancel
                                </Button>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
            <DeletePopUp
                isDialogOpen={confirmationDialog}
                onCancel={() => setConfirmationDialog(false)}
                onDo={deleteItem}
                title="Delete location"
                recordName="location"
            />
        </React.Fragment>
    );
}
export default React.memo(AddEditLocationWidget);
